// Fonts zelf gehost (fontsource, latin-subset): de CSP laat geen Google Fonts toe.
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/jetbrains-mono/latin-400.css";
import "@fontsource/jetbrains-mono/latin-500.css";
import "@fontsource/jetbrains-mono/latin-600.css";
import "./styles/theme.css";
import "./styles/base.css";
import "./styles/shell.css";
import "./styles/components.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Providers from "app/Providers";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);
